var map = {
	"./Footer-background.webp": "371f",
	"./Group.png": "0caf",
	"./Hexagon2.png": "1657",
	"./about-us.jpg": "768f",
	"./background-honey.png": "7bcc",
	"./bee-line-rev.png": "13c4",
	"./bee-line.png": "1f52",
	"./benefit.jpg": "30c2",
	"./blog_03-755x505.jpg": "1861",
	"./comment-honey.png": "0bc2",
	"./comment/user-face-1.jpg": "fe6f",
	"./comment/user-face-2.jpg": "aee1",
	"./comment/user-face-3.jpg": "cdef",
	"./detect.webp": "25e0",
	"./dotts.png": "551f",
	"./flowers_1.png": "7ae3",
	"./flowers_2.png": "e08f",
	"./gallery/gallery-1.jpg": "f4d1",
	"./gallery/gallery-2.jpg": "64e4",
	"./gallery/gallery-3.jpg": "a5bf",
	"./gallery/gallery-4.jpg": "f465",
	"./gallery/gallery-5.jpg": "87a1",
	"./gallery/gallery-6.jpg": "e964",
	"./gallery/gallery-7.jpg": "42f4",
	"./gallery/gallery-8.jpg": "3a73",
	"./gallery/gallery-9.jpg": "5e61",
	"./header1.jpg": "c32d",
	"./header2.jpg": "b6cb",
	"./header3.jpg": "cbe0",
	"./hexagon-mask.png": "60af",
	"./honey-splash.png": "02d4",
	"./honeyBee-2.webp": "73be",
	"./honeyBee.png": "fa16",
	"./lemon.jpg": "043e",
	"./line.png": "4a63",
	"./logo.png": "7114",
	"./moom.jpg": "9ed7",
	"./produce-1.png": "5761",
	"./produce-2.png": "03ca",
	"./produce-3.png": "6859",
	"./produce-4.png": "9ae4",
	"./product/product-1.jpg": "8ee8",
	"./product/product-2.jpg": "2b1f",
	"./product/product-3.jpg": "c32b",
	"./product/product-4.jpg": "6a97",
	"./product/product-5.jpg": "e199",
	"./product/product-6.jpg": "1db1",
	"./product/product-7.webp": "8876",
	"./section.png": "8ade",
	"./slashio-photography-iOuEGWPB22U-unsplash.jpg": "b631",
	"./video-photo.jpg": "3e67",
	"./work1.png": "6bc3",
	"./work2.png": "791a",
	"./work3.png": "a320"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b772";